<template>
    <div>
        <crud-facecade
            ref="drug_list"
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            v-wechat-title="title"
            :tableHeight="tableHeight"
            :searchLocal="false"
            :columnConfig="true"
            :addButton="{ permission: 'drug:create' }"
            :deleteButton="{ permission: 'drug:delete' }"
            :updateButton="{ permission: 'drug:update' }"
        >
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="runCarteServer">同步</el-button>
            </template>
        </crud-facecade>

        <el-pagination
            class="align-left"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="refreshList"
            @current-change="refreshList"
            :page-sizes="[10, 20, 50, 100, 200]"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            :total="total"
        >
        </el-pagination>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `Drug`,
    props: {},
    data() {
        return {
            title: `基础数据-药品`,
            currentPage: 1,
            pageSize: 50,
            total: 0,
            url: {
                baseURL: `/api/AcisSystem/Drug`,
                get: q => {
                    // return new Promise(resolve => {
                    //     let req = this.myaxios.get(`/api/AcisSystem/Drug/GetPage`, q)
                    //     req.then(data => {
                    //         // let r =data.map(d=>{
                    //         //   d.drug_types = d.drug_types&&d.drug_types.map(dt=>dt.id)||[]
                    //         //   // d.drug_type_names = d.drug_types&&d.drug_types.map(dt=>dt.name).toString()||''
                    //         //   return d
                    //         // })
                    //         resolve(data)
                    //     })
                    // })

                    let that = this

                    q.page = that.currentPage
                    q.pageSize = that.pageSize
                    return new Promise(resolve => {
                        let req = that.myaxios.postpagination(`/api/AcisSystem/Drug/GetPageNew`, q
                        )
                        req.then(res => {
                            this.total = res.count
                            var data = res.data
                            resolve(data)
                        }).catch(e => {
                            console.log(e)
                            resolve([])
                        })
                    })
                }
            },
            buttons: [],
            allDrugWay: []
        }
    },
    created() {
        this.$store.dispatch(`drug/ADD_DRUG_TYPE`)
        this.$store.dispatch(`drug/ADD_DRUG_UNIT`)
        this.loadAllDrugWay()
        this.$store.dispatch(`drug/ADD_DRUG_WAY`)
    },
    computed: {
        ...mapGetters([`drug/drug_type`, `drug/drug_unit`, `screenHeight`, `drug/drug_way`, `hospital_ward_auth`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    // width: "180",
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    readonly: false,
                    sortable: true,
                    isDisplayOrder: true
                },
                {
                    type: `string`,
                    prop: `code`,
                    label: `编码`,
                    width: `180`,
                    isListable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    width: `200`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    // sortable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `abbr`,
                    label: `缩写`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: false,
                    searchable: false,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `full_name`,
                    label: `全称`,
                    width: `200`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    // sortable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }, {
                    type: `select`,
                    prop: `dic_hospital_ward_id`,
                    label: `所属机构`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: this[`hospital_ward_auth`]
                }, {
                    type: `select`,
                    prop: `dic_hospital_ward_id`,
                    label: `所属机构`,
                    width: `120`,
                    isEditable: true,
                    readonly: true,
                    sortable: true,
                    options: this[`hospital_ward_auth`]
                },
                {
                    type: `string`,
                    prop: `drug_type_names`,
                    label: `药品类型`,
                    width: `120`,
                    isListable: true,
                    isExpand: false
                    // sortable: true
                },
                {
                    type: `multiselect`,
                    prop: `drug_types`,
                    label: `药品类型`,
                    width: `120`,
                    isListable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    options: this[`drug/drug_type`],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: false,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `sell_unit`,
                    label: `计价单位`,
                    width: `60`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false
                    // sortable: true,
                    // options:this["drug/drug_unit"]
                },
                {
                    type: `string`,
                    prop: `price`,
                    label: `价格`,
                    width: `60`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `dose`,
                    label: `包装剂量`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `UseDose`,
                    label: `使用剂量`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `concentration`,
                    label: `默认浓度`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: false
                },
                {
                    type: `select`,
                    prop: `concentration_unit`,
                    label: `浓度单位`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: false,
                    options: _.filter(this[`drug/drug_unit`], { isspeed: false, isconcentration: true }).map(d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    })
                },
                {
                    type: `select`,
                    prop: `dic_unit_id`,
                    label: `药品单位`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: true,
                    options: _.filter(this[`drug/drug_unit`], { isspeed: false, isconcentration: false }).map(d => {
                        return {
                            label: `${d.label}`,
                            value: d.value,
                            disabled: d.disabled
                        }
                    })
                },

                {
                    type: `float`,
                    prop: `default_speed_dose`,
                    label: `默认流量`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: false
                },
                {
                    type: `select`,
                    prop: `dic_speed_unit_id`,
                    label: `药品流速单位`,
                    width: `120`,
                    isListable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: true,
                    options: _.filter(this[`drug/drug_unit`], { isspeed: true, isconcentration: false }).map(d => {
                        return {
                            label: `${d.label}`,
                            value: d.value,
                            disabled: d.disabled
                        }
                    })
                },
                {
                    type: `select`,
                    prop: `dic_add_drug_way_id`,
                    label: `用药途径`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    sortable: true,
                    options: (that, { row }) => {
                        if (this.$refs[`drug_list`].createDialog.dialogFormVisible || this.$refs[`drug_list`].editDialog.dialogFormVisible) {
                            return this[`drug/drug_way`]
                        } else {
                            // return this.loadAllDrugWay()
                            return this.allDrugWay
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `expression_description`,
                    label: `计算表达式描述`,
                    width: `200`,
                    isListable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false
                },
                {
                    type: `string`,
                    prop: `speed_to_dose_expression`,
                    label: `通过流量求用量计算表达式`,
                    width: `200`,
                    isListable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false
                },
                {
                    type: `string`,
                    prop: `dose_to_speed_expression`,
                    label: `通过用量反推流量计算表达式`,
                    width: `200`,
                    isListable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false
                },
                {
                    type: `string`,
                    prop: `firm`,
                    label: `厂商`,
                    width: `200`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false
                },
                {
                    type: `select`,
                    prop: `is_continue`,
                    label: `是否连续`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    default: false
                },
                {
                    type: `select`,
                    prop: `is_speed`,
                    label: `是否流量`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    default: false
                },
                {
                    type: `rbool`,
                    prop: `is_deleted`,
                    label: `状态`,
                    width: `70`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: false,
                    readonly: false,
                    options: `is_enabled`,
                    default: false
                },
                {
                    type: `select`,
                    prop: `enable_concentration`,
                    label: `启用浓度`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    default: false
                },
                {
                    type: `select`,
                    prop: `is_medicine`,
                    label: `是否医保`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    default: false
                },
                {
                    type: `select`,
                    prop: `is_before_surgery`,
                    label: `是否术前`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    default: false
                }, {
                    type: `string`,
                    prop: `limit_usage`,
                    label: `单次限制用量`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: false
                }, {
                    type: `select`,
                    prop: `limit_usage_unit`,
                    label: `单次限制用量单位`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    options: _.filter(this[`drug/drug_unit`]).map(d => {
                        return {
                            label: `${d.label}`,
                            value: d.value,
                            disabled: d.disabled
                        }
                    })
                }, {
                    type: `string`,
                    prop: `batch_no`,
                    label: `批号`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: false
                }, {
                    type: `number`,
                    prop: `reference_number`,
                    label: `基数`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: false
                }, {
                    type: `number`,
                    prop: `inventory`,
                    label: `库存`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: false
                }
            ]
        }
    },
    mounted() {},
    methods: {
        refreshList() {
            this.$refs[`drug_list`].ReloadListData()
        },
        runCarteServer() {
            let req = this.myaxios.post(`/api/Anonymous/Carte/RunCarteServer?type=carte_dic_drug&paramStr=1`)
            req.then(data => {
                this.$refs[`drug_list`].ReloadListData()
            }).catch(e => {
                console.log(e)
            })
        },
        loadAllDrugWay() {
            let req = this.myaxios.get(`/api/AcisSystem/AddDrugWay/GetAll`)
            req.then(data => {
                this.allDrugWay = _.map(data, d => {
                    return {
                        label: `${d.name}`,
                        value: d.id,
                        jianpin: d.code,
                        disabled: d.is_deleted
                    }
                })
            }).catch(error => {
                console.log(error)
            })
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Drug/Index.vue